import { version } from "vite";
var majorVersion = parseInt(version.split(".")[0], 10);
function isRolldown() {
  return majorVersion >= 8;
}
export {
  isRolldown
};
//# sourceMappingURL=isRolldown.js.map
